import { apiClient } from '../../../utils/Api';

class UploadAdapter {
  constructor(loader) {
    this.loader = loader;
    this.controller = new AbortController();
  }

  upload() {
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          const formData = new FormData();
          formData.append('file', file);
          formData.append('name', 'editor-images/' + file.name);
          formData.append('bucket_type', 'assets');

          apiClient()
            .post('admins/assets', formData, {
              signal: this.controller.signal,
            })
            .then((res) => {
              const data = res.data.data;
              const url = data && data.url ? data.url : data;
              resolve({ default: url });
            })
            .catch((err) => {
              if (err.name === 'AbortError' || err.code === 'ERR_CANCELED') {
                return;
              }
              reject(
                err.response && err.response.data && err.response.data.message
                  ? err.response.data.message
                  : 'Upload failed'
              );
            });
        })
    );
  }

  abort() {
    this.controller.abort();
  }
}

export default function uploadAdapterPlugin(editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    return new UploadAdapter(loader);
  };
}
